import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BasePostProvider } from "@tendercuts/http";
import { GenericServerResponse } from "@tendercuts/models";

@Injectable()
export class HoldOrderService extends BasePostProvider<GenericServerResponse> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenericServerResponse {
    return GenericServerResponse;
  }

  get endpoint(): string {
    return this.endpointService.holdOrder();
  }

  get isCachable(): boolean {
    return false;
  }

  getparams(
    orderId: string,
    option: string,
    items: any[] = [],
  ): {
    increment_id: string;
    reason: string;
    items: any[];
  } {
    const params: {
      increment_id: string;
      reason: string;
      items: any[];
    } = {
      increment_id: orderId,
      reason: option,
      items,
    };

    return params;
  }
}
